<template>
  <div style="margin: 10px 5px">
    <span>この商品に関連するタグ</span><br>
    <el-tag
      v-for="(tag, idx) in tags"
      :key="idx"
      type="info"
      style="margin-left: 5px; margin-top: 5px"
    >
      {{ tag.name }}
    </el-tag>
    <el-row style="margin-top: 10px">
      <el-col :offset="10" :span="2">
        <el-button type="text" @click="visible = true">タグを選択</el-button>
      </el-col>
    </el-row>
    <el-dialog
      width="70%"
      top="50px"
      :visible.sync="visible"
      title="タグの設定"
    >
      <div style="overflow-y: scroll; max-height: 500px">
        <el-checkbox-group v-model="selectedIds" @change="changeTags($event)">
          <el-row
            v-for="(tagGroup, idx) in tagGroups"
            :key="idx"
            style="margin: 20px;"
          >
            <div style="font-size: large">{{ tagGroup.name }}</div>
            <el-col
              :span="8"
              v-for="(tag, tagIdx) in tagGroup.tags"
              :key="tagIdx"
              style="padding: 5px"
            >
              <div style="background-color: rgb(230, 230, 230); padding: 10px">
                <el-checkbox
                  :label="tag.id"
                >
                  {{ tag.name }}
                </el-checkbox>
              </div>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </div>
      <el-row slot="footer" type="flex">
        <el-button type="primary" @click="closeDialog">
          閉じる
        </el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TagsArea',
  props: {
    tags: {
      type: Array
    },
    tagGroups: {
      type: Array
    }
  },
  watch: {
    tags: function (newValue) {
      this.selectedIds = []
      for (const tag of newValue) {
        this.selectedIds.push(tag.id)
      }
    },
    tagGroups: function (newValue) {
      for (const tagGroup of newValue) {
        for (const tag of tagGroup.tags) {
          this.mapTags[tag.id.toString()] = tag
        }
      }
    }
  },
  data: function () {
    return {
      visible: false,
      selectedIds: [],
      mapTags: {}
    }
  },
  methods: {
    closeDialog: function () {
      this.visible = false
    },
    changeTags: function (value) {
      const newValue = []
      for (const tagId of value) {
        newValue.push(this.mapTags[tagId.toString()])
      }
      this.$emit('update:tags', newValue)
    }
  }
}
</script>
